import { GallectionSortOrder, GallectionType } from '../../types/gallection';

export const FOLDER_DEVIATIONS_STREAM_GROUP_ID = 'folder-deviations';
export const GALLECTION_SEARCH_STREAM_GROUP_ID = 'gallection-search';
export const DEVIATIONS_PER_FETCH_COUNT = 24;
export const STREAM_PARAM_TYPE_FETCHING_PAUSED = 'fetching_paused';

export const getFolderDeviationsStreamId = (gallectionType: GallectionType, folderId) => {
  const params = [gallectionType, folderId];
  return `${FOLDER_DEVIATIONS_STREAM_GROUP_ID}-${params.join('-')}`;
};

interface GallectionSearchStreamIdParams {
  gallectionType: GallectionType;
  mode: 'paged' | 'scroll';
  page?: number;
  searchQuery: string;
  sortOrder: GallectionSortOrder;
}

export const getGallectionSearchStreamId = ({
  gallectionType,
  mode,
  page,
  searchQuery,
  sortOrder,
}: GallectionSearchStreamIdParams) => {
  const streamKey = encodeURIComponent(searchQuery);
  const params = [mode, gallectionType, sortOrder, streamKey];

  if (mode === 'paged') {
    params.push(String(page ?? 1));
  }

  return `${GALLECTION_SEARCH_STREAM_GROUP_ID}-${params.join('-')}`;
};
